import gql from 'graphql-tag';
import { GROUP_TYPE } from './GroupType.gql';

export const ADD_GROUP_MUTATION = gql`
  ${GROUP_TYPE}
  mutation addGroup($groupData: GroupInput!) {
    createGroup(groupData: $groupData) {
      group {
        ...GroupType
      }
    }
  }
`;
